import { h, app } from "hyperapp";
import { AllHtmlEntities as Entities } from "html-entities";

const entities = new Entities();

// onclick events for
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

const Dropdown = ({
  header,
  list,
  onClickFunc,
  ariaLabel,
  disabled = false,
  selectedItem = null
}) => {
  list = [{ id: "", name: header }, ...list];

  return (
    <ul class="clarku-dropdown">
      <li>
        <button
          disabled={disabled}
          oncreate={el => {
            $(el).on("click", toggleDropdown);
            $(el).on("blur", function(e) {
              if (isIE11) {
                return;
              }

              if (!e.relatedTarget) {
                toggleDropdown(e);
              }

              if (
                e.relatedTarget &&
                !e.relatedTarget.classList.contains("clarku-dropdown__item")
              ) {
                toggleDropdown(e);
              }
            });
          }}
          aria-label={entities.decode(ariaLabel)}
          class="reset unselected clarku-dropdown__header"
        >
          {entities.decode(selectedItem ? selectedItem : header)}
        </button>
        <div class="clarku-dropdown__dropdown">
          {list.map(item => {
            return (
              <button
                oncreate={el => {
                  $(el).on("click", closeDropdown.bind(el));
                }}
                onclick={e => onClickFunc(e, item.id, item.name)}
                class="clarku-dropdown__item reset"
                data-id={item.id}
                aria-label={"Select " + entities.decode(item.name)}
              >
                {entities.decode(item.name)}
              </button>
            );
          })}
        </div>
      </li>
    </ul>
  );
};

const updateDropdownMenu = ($li, $dropdown) => {
  let title = $li.textContent;
  let id = $li.getAttribute("data-id");
  let $header = $($dropdown).find(".clarku-dropdown__header");

  $header
    .removeClass("unselected")
    .text(title)
    .attr("data-id", id);
  $dropdown.toggleClass("active");
  $dropdown.attr(
    "aria-expanded",
    $dropdown.attr("aria-expanded") === "false" ? "true" : "false"
  );

  if ("" === id) {
    $header.addClass("unselected");
  }
};

function toggleDropdown(e) {
  let $dropdown = e.currentTarget.parentNode.parentNode;

  if ($dropdown.classList.contains("active")) {
    $dropdown.classList.remove("active");
    $dropdown.setAttribute("aria-expanded", "false");
    return;
  }

  // Other dropdowns close.
  $(".clarku-dropdown").removeClass("active");
  $dropdown.classList.toggle("active");
  $dropdown.setAttribute(
    "aria-expanded",
    $dropdown.getAttribute("aria-expanded") === "false" ? "true" : "false"
  );
}

function closeDropdown() {
  let $select = $(this).parents(".clarku-dropdown");
  updateDropdownMenu(this, $select);
}

module.exports = Dropdown;



// WEBPACK FOOTER //
// ./assets/js/inc/Dropdown.js